import { Any, JsonObject, JsonProperty } from 'json2typescript';
import { MatchState } from '../../enums/users/match-state.enum';

@JsonObject('UserMatch')
export class UserMatch {

  @JsonProperty('match_id', Number)
  matchId: number = 0;

  @JsonProperty('match_variant_id', Number)
  matchVariantId: number = 0;

  @JsonProperty('match_state', Number)
  matchState: MatchState = MatchState.None;

  @JsonProperty('match_table_cost', Number)
  matchTableCost: number = 0;

  @JsonProperty('match_start_timestamp', Number)
  matchStartTimestamp: number = 0;

  @JsonProperty('match_end_timestamp', Number)
  matchEndTimestamp: number = 0;

  @JsonProperty('match_server_id', Any)
  matchServerId: string | null = null;

  @JsonProperty('rank', Number)
  rank: number = 0;

  @JsonProperty('is_exited', Boolean)
  isExited: boolean = false;

  @JsonProperty('score', Number)
  score: number = 0;

  @JsonProperty('matchmaker_ticket_id', Any)
  matchmakerTicketId: string | null = null;

  @JsonProperty('matchmaker_player_session_id', Any)
  matchmakerPlayerSessionId: string | null = null;
}
